module.exports = __webpack_public_path__ + "img/19_chickenrice.a8422637.jpg";